import { IconButton, Stack, Typography } from "@mui/material"
import Frame from "../Frames/Basic"
import { ArrowBack } from "@mui/icons-material"
import { Link, useNavigate } from "react-router-dom"
import Course from "./Course"
import { useState, useEffect } from "react"
import API from "../../services/API"
import Loader from "../Tools/Loader"

export default function Tutos(){

    const [courses, setCourses] = useState(null)

    const navigate = useNavigate()

    useEffect(() => {

        API.get('/courses?type=tuto')
            .then(r => setCourses(r.data))
            .catch(e => console.log(e.response?.data))

    }, [])


    return <Frame>

        <Stack spacing={3}>

            <Stack direction='row' alignItems='center' spacing={1}>

                <Link to="/enrollments">
                    <IconButton>
                        <ArrowBack />
                    </IconButton>
                </Link>

                <Typography variant='h2'>Tutoriels de Prise en Charge</Typography>
                
            </Stack>

        
            {!courses && <Loader />}


            <Stack direction='row' flexWrap='wrap'>

                {(courses || []).map(c => 
                    <Course 
                        key={c.id}
                        id={c.id}
                        picture={c.picture?.url}
                        title={c.title}
                        subtitle={c.teachers}
                        button="Voir le tuto"
                        onClick={() => navigate(`/study/${c.id}`)}
                    />  
                )}

            </Stack>


            {(courses && !courses.length) &&
                <Typography align="center" sx={{alignSelf: 'center'}}>
                    <i>Aucun tutoriel à afficher</i>
                </Typography>
            }
            
        </Stack>

    </Frame>
}